/**
 * @file validate failed view
 * @author chenqiang(chenqiang03)
 */
import * as React from 'react';
import classNames from 'classnames';
import useMemo from 'rc-util/lib/hooks/useMemo';
import useCacheErrors from './hooks/useCacheErrors';
import useForceUpdate from '../_util/hooks/useForceUpdate';
import { FormItemPrefixContext } from './context';
const EMPTY_LIST = [];
export default function ErrorList({ errors = EMPTY_LIST, help, onDomErrorVisibleChange, }) {
    const forceUpdate = useForceUpdate();
    const { prefixCls, status } = React.useContext(FormItemPrefixContext);
    const [visible, cacheErrors] = useCacheErrors(errors, changedVisible => {
        if (changedVisible) {
            Promise.resolve().then(() => {
                onDomErrorVisibleChange === null || onDomErrorVisibleChange === void 0 ? void 0 : onDomErrorVisibleChange(true);
            });
        }
        forceUpdate();
    }, !!help);
    const memoErrors = useMemo(() => cacheErrors, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    visible, (_, nextVisible) => nextVisible);
    // Memo status in same visible
    const [innerStatus, setInnerStatus] = React.useState(status);
    React.useEffect(() => {
        if (visible && status) {
            setInnerStatus(status);
        }
    }, [visible, status]);
    const baseClassName = `${prefixCls}-item-explain`;
    return visible && (<div key="help" className={classNames(baseClassName, {
            [`${baseClassName}-${innerStatus}`]: innerStatus,
        })}>
            {memoErrors.map((error, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} role="alert">
                    {error}
                </div>))}
        </div>);
}
